import { render, staticRenderFns } from "./ContactPersons.vue?vue&type=template&id=da93bb96"
import script from "./ContactPersons.vue?vue&type=script&lang=js"
export * from "./ContactPersons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports